import moment from 'moment';

/**
 * Copyright (c) 2019, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import PropTypes from 'prop-types';

import React from 'react';
import styled from 'styled-components';
import LeftButton from './LeftButton';
import RightButton from './RightButton';
import Week from './Week';

const TodayTableData = styled.td`
  color: #0070d2;
  cursor: pointer;
`;

/**
 * This component renders the actual calender using SLDS classes
 */
export default class DateDropdown extends React.Component {
  static propTypes = {
    dateTime: PropTypes.object,
    onChange: PropTypes.func,
    dateLimitInDays: PropTypes.number
  };

  render() {
    const { onChange } = this.props;
    const dateLimitInDays = this.props.dateLimitInDays || 33;
    const today = moment();
    let dateTime = this.props.dateTime || today;
    const dateCursor = dateTime
      .clone()
      .date(1)
      .day(0); //first day of the week in which the month starts
    const endOfMonth = dateTime.clone().endOf('month'); //right before midngith, end of month
    const daysOfWeekFull = moment.weekdays();
    const daysOfWeekAbbreviated = moment.weekdaysShort();
    const startDays = [];
    while (dateCursor.isBefore(endOfMonth)) {
      startDays.push(dateCursor.clone());
      dateCursor.add(7, 'd');
    }
    const selectedDateOffset = parseInt(
      moment.duration(today.diff(dateCursor)).asDays(),
      10
    );
    const firstStartDayOffset = parseInt(
      moment.duration(today.diff(startDays[0])).asDays(),
      10
    );
    const hasMaxLimitReached = selectedDateOffset <= 0;
    const hasMinLimitReached = firstStartDayOffset >= dateLimitInDays;
    return (
      <div
        className="slds-dropdown slds-dropdown--left slds-datepicker"
        style={{ left: '-10rem' }}
      >
        <div className="slds-datepicker__filter slds-grid">
          <div className="slds-datepicker__filter--month slds-grid slds-grid--align-spread slds-size--4-of-4">
            <div className="slds-align-middle">
              <LeftButton
                disabled={hasMinLimitReached}
                onClick={() => {
                  if (!hasMinLimitReached) {
                    onChange(dateTime.subtract(1, 'M'));
                  }
                }}
              />
            </div>
            <h2
              id="month"
              className="slds-align-middle"
              aria-live="assertive"
              aria-atomic="true"
            >
              {dateTime.format('MMMM')}
            </h2>
            <div className="slds-align-middle">
              <RightButton
                disabled={hasMaxLimitReached}
                onClick={() => {
                  if (!hasMaxLimitReached) {
                    onChange(dateTime.add(1, 'M'));
                  }
                }}
              />
            </div>
          </div>
        </div>
        <table className="datepicker__month" role="grid">
          <thead>
            <tr id="weekdays">
              {daysOfWeekAbbreviated.map((day, index) => {
                return (
                  <th key={day} scope="col">
                    <abbr title={daysOfWeekFull[index]}>{day}</abbr>
                  </th>
                );
              })}
            </tr>
          </thead>
          <tbody>
            {startDays.map((weekStartDate, i) => {
              return (
                <Week
                  {...{ weekStartDate, dateTime, onChange }}
                  key={weekStartDate}
                  dateLimitInDays={dateLimitInDays}
                />
              );
            })}
            <tr>
              <td />
              <td />
              <td />
              <TodayTableData onClick={() => onChange(today)}>
                {'Today'}
              </TodayTableData>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}
